// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__oTFex","emails":"CreateEditClinics_emails__1jNAw","emailTagLabel":"CreateEditClinics_emailTagLabel__2U6ts"};